'use client';
import Link from 'next/link';
import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing(8, 0, 8, 0)};
  gap: ${({ theme }) => theme.spacing(1)};
  display: flex;
  flex-direction: column;
  padding: ${({ theme }) => theme.spacing(0, 8, 0, 8)};
  @media ${({ theme }) => theme.tablet} {
    margin-left: auto;
    margin-right: auto;
    width: 480px;
  }
`;

export const RadioCellContainer = styled.div`
  fieldSet {
    padding: 0;
  }
`;

export const WeightInputContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const Label = styled.label`
  ${({ theme }) => theme.typography.body};
  color: ${({ theme }) => theme.colors.text.secondary};
  padding-bottom: ${({ theme }) => theme.spacing(2)};
  display: inline-block;
`;

export const StyledEmailForm = styled.form`
  width: 100%;

  @media ${({ theme }) => theme.tabletL} {
    max-width: 640px;
  }
`;

export const GridWrapper = styled.div`
  div {
    background-color: ${({ theme }) => theme.colors.background.lightest};
  }
`;

export const SMSTermsAndConditions = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  ${({ theme }) => theme.typography.body};

  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const SMSTermsAndConditionsLink = styled(Link)`
  color: ${props => props.theme.colors.text.secondary};
  text-decoration: underline;
`;

export const LoginPrompt = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  ${({ theme }) => theme.typography.body};

  margin-top: ${({ theme }) => theme.spacing(2)};
`;

export const LoginPromptLink = styled(Link)`
  color: ${props => props.theme.colors.text.secondary};
  text-decoration: underline;
`;
